import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './app.guard';
import { AuthenticatedLayoutComponent } from './layouts/authenticated-layout/authenticated-layout.component';
import { NoAuthenticatedLayoutComponent } from './layouts/no-authenticated-layout/no-authenticated-layout.component';
import { UserProfileComponent } from './components/user/user-profile.component';
import { AuthCallbackComponent } from './modules/auth/pages/auth-callback/auth-callback.component';
import { ContractsViewComponent } from './components/contracts/contracts-view/contracts-view.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./layouts/authenticated-layout/authenticated-layout.module').then(m => m.AuthenticatedLayoutModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  // {
  //   path: 'contracts/:id', 
  //   component: ContractsViewComponent,
  //   // data: { pageTitle: 'CONTRACT_DETAILS' } 
  // },
  {
    //localhost:4200/public/contract-access-request-confirmation?country=PT&token=07ee5bb7-330b-4195-b0e3-6de7490d8dfc
    // Kept for links already sent by email; query params are preserved on redirect
    path: 'public/contract-access-request-confirmation', redirectTo: 'auth/contract-access-request-confirmation', pathMatch: 'full'
  },
  // Fallback when no prior routes is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },  
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled', // Don't perform initial navigation in iframes
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
